// components/RelatedPatents.tsx
// Server Component - no "use client" needed!

interface RelatedPatentsProps {
  keywords: string[];
}

export async function RelatedPatents({ keywords }: RelatedPatentsProps) {
  // Fetch at build time (server-side)
  let patents: string[] = [];
  
  try {
    // Fetch all keywords in parallel
    const results = await Promise.all(
      keywords.map(keyword =>
        fetch('https://thedailydialectics.com/api/registry/search/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: keyword, type: 'path' }),
          cache: 'force-cache'  // Cache for static generation
        }).then(r => r.ok ? r.json() : { result: [] })
      )
    );
    
    // Combine and deduplicate
    const combined = results.flatMap(r => r.result || []);
    const unique = [...new Set(combined.map((p: any) => p.url_path))];
    patents = unique.slice(0, 10); // Top 10
  } catch (error) {
    console.error('Failed to fetch related patents:', error);
  }
  
  if (patents.length === 0) {
    return <div className="related-patents-empty">No related patents found</div>;
  }
  
  return (
    <div className="related-patents">
      <h3>Related Patents</h3>
      <ul>
        {patents.map((patent: string) => (
          <li key={patent}>
            <a href={patent}>{patent}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
